import styled from '@emotion/styled/macro';
import { Link } from 'react-router-dom';

import { linkWithUnderlineHover } from 'styles/mixins';
import { css } from '@emotion/react';

interface BarProps {
  width?: number;
  color?: 'primary' | 'secondary';
}

const Wrapper = styled.div`

`;

const Bar = styled.div<BarProps>`
  position: relative;
  width: ${(props) => props.width}%;
  height: 1rem;
  margin-right: 2rem;
  margin-bottom: .4rem;
  border-radius: .2rem;
  background: ${(props) => props.theme.color.gray};
  span {
    position: absolute;
    top: -.4rem;
    right: -2.5rem;
    width: 2.5rem;
    padding-left: .5rem;
    color: #a0a0a0;
  }

  ${(props) => props.color === 'primary' && css`
    background: #00b8ff;
  `};
  ${(props) => props.color === 'secondary' && css`
    background: #f77169;
  `};

  /* background: #ff9500;
     background: #81cf25;
     background: #4075ee;
     background: #ae6ee7;
     background: #46cf83;
     background: #f55043;
     background: #e7d815;
     background: #7568e2;
     background: #54ccd5; */
`;

const List = styled.ul`
  max-width: 30rem;
  margin: 0;
  font-size: 1.2rem;
  list-style: none;
`;

const ListItem = styled.li`
  margin-right: 2.5rem;
  & + & {
    margin-top: 1rem;
  }
`;

const ListLink = styled(Link)`
  ${linkWithUnderlineHover('&', 1, '#a0a0a0')};
`;

const ElementName = styled.span`
  overflow: hidden;
  max-width: 17rem;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export {
  Wrapper,
  List,
  ListItem,
  ListLink,
  Bar,
  ElementName
};
